import React from 'react';

function Card(props) {
    const { card, color, colorKind, number, keyID, translateY, translateX, data, id } = props;
    return (
        <div id={id} draggable="true" data-role={data} className={`${card} ${color}`} key={keyID} style={{ transform: `translate(${translateX}%, ${translateY}px)`, zIndex: keyID }}>
            <div className="upArea">
                <span id="left">{number}</span>
                <span id="right">{colorKind}</span>
            </div>
            <div className="downArea">
                <span>{colorKind}</span>
            </div>
        </div>
    );
}

export default Card;
